import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import settings from '@/settings/public'

/**
 * Module-level on purpose, never an inline literal. The library re-runs its
 * injection effect whenever `JSON.stringify(scriptProps)` changes, and its
 * cleanup is a hard teardown — it removes the script node, deletes the badge
 * and sets `window.___grecaptcha_cfg = undefined`. A value that could ever vary
 * would re-inject grecaptcha mid-session, reset `executeRecaptcha` to undefined
 * and re-arm `useRecaptcha`'s ready-wait on live users. A frozen identity makes
 * that impossible by construction.
 *
 * `appendTo` stays at its `head` default and `useRecaptchaNet` stays off:
 * changing the script host changes the CSP and ad-blocker profile.
 */
const RECAPTCHA_SCRIPT_PROPS = { async: true, defer: true }

export const RecaptchaProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={settings?.recaptcha?.key || ''}
      scriptProps={RECAPTCHA_SCRIPT_PROPS}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
